module.exports = __webpack_public_path__ + "b48418677babcd39a084459c30d64bfa.svg";